<template>
  <!-- Site wrapper -->
  <div class="wrapper">
    <cabecalho tituloPagina="Escritórios" />
    <menuLateral/>

      <ContratoModalVerificaCancelamento
        v-if="informacoesContrato"
        :resumoContrato="informacoesContrato"
        :isVencido="false"
        :modalCancelamento="$refs.contratoModalCancelamento"
        ref="contratoModalVerificaCancelamento"
      />

      <ContratoModalCancelamento
        v-if="informacoesContrato"
        :resumoContrato="informacoesContrato"
        :isVencido="false"
        @obterResumoContrato="redirecionarParaListagemEscritorios"
        ref="contratoModalCancelamento"
      />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6"></div>
          </div>
        </div><!-- /.container-fluid -->
      </section>
      <!-- Main content -->
      <section class="content">
        <!-- Default box -->
        <div class="card">

          <div class="card-body">
            <div class="row">
              <div class="col-4 col-sm-3 col-xl-2">
                <nav class="nav nav-pills flex-column nav-tabs h-100" id="vert-tabs-tab" role="tablist" aria-orientation="vertical">
                  <a
                    class="nav-link"
                    :class="{ active: abaSelecionada.informacoes }"
                    id="vert-tabs-informacoes-tab"
                    data-toggle="pill"
                    href="#vert-tabs-informacoes"
                    role="tab"
                    aria-controls="vert-tabs-informacoes"
                    aria-selected="true">
                    <b>Informações</b> <i v-if="flagAbas.informacoes" class="fas fa-exclamation-triangle"></i>
                  </a>
                  <a
                    class="nav-link"
                    :class="{ active: abaSelecionada.endereco }"
                    id="vert-tabs-endereco-tab"
                    data-toggle="pill"
                    href="#vert-tabs-endereco"
                    role="tab"
                    aria-controls="vert-tabs-endereco"
                    aria-selected="false">
                    <b>Endereço</b> <i v-if="flagAbas.endereco" class="fas fa-exclamation-triangle"></i>
                  </a>
                  <a
                    class="nav-link"
                    :class="{ active: abaSelecionada.contato }"
                    id="vert-tabs-contato-tab"
                    data-toggle="pill"
                    href="#vert-tabs-contato"
                    role="tab"
                    aria-controls="vert-tabs-contato"
                    aria-selected="false">
                    <b>Contato</b> <i v-if="flagAbas.contato" class="fas fa-exclamation-triangle"></i>
                  </a>
                  <a
                    v-if="visibilidadeAbas.produtos"
                    @click="eventoClickProdutos"
                    class="nav-link"
                    :class="{ disabled: flagsDeControle.carregandoDados.status}"
                    id="vert-tabs-produtos-tab"
                    data-toggle="pill"
                    href="#vert-tabs-produtos"
                    role="tab"
                    aria-controls="vert-tabs-produtos"
                    aria-selected="false">
                    <b>Produtos</b>
                  </a>
                  <a
                    v-if="visibilidadeAbas.recursos"
                    @click="eventoClickRecursos"
                    class="nav-link"
                    id="vert-tabs-recurso-tab"
                    data-toggle="pill"
                    href="#vert-tabs-recurso"
                    role="tab"
                    aria-controls="vert-tabs-recurso"
                    aria-selected="false">
                    <b>Recursos Disponíveis</b>
                  </a>
                  <a
                    v-if="visibilidadeAbas.pedidos"
                    @click="eventoClickPedidos"
                    class="nav-link"
                    :class="{ disabled: flagsDeControle.carregandoDados.status}"
                    id="vert-tabs-pedidos-tab"
                    data-toggle="pill"
                    href="#vert-tabs-pedidos"
                    role="tab"
                    aria-controls="vert-tabs-pedidos"
                    aria-selected="false">
                    <b>Pedidos</b>
                  </a>
                  <a
                    v-if="visibilidadeAbas.faturas"
                    @click="eventoClickFaturas"
                    class="nav-link"
                    :class="{ disabled: flagsDeControle.carregandoDados.status}"
                    id="vert-tabs-faturas-tab"
                    data-toggle="pill"
                    href="#vert-tabs-faturas"
                    role="tab"
                    aria-controls="vert-tabs-faturas"
                    aria-selected="false">
                    <b>Faturas</b>
                  </a>
                  <a
                    v-if="visibilidadeAbas.usuarios"
                    @click="eventoClickUsuarios"
                    class="nav-link"
                    :class="{ disabled: flagsDeControle.carregandoDados.status}"
                    id="vert-tabs-usuarios-tab"
                    data-toggle="pill"
                    href="#vert-tabs-usuarios"
                    role="tab"
                    aria-controls="vert-tabs-usuarios"
                    aria-selected="false">
                    <b>Usuários</b>
                  </a>
                </nav>
              </div>
              <div class="col-8 col-sm-9 col-xl-10">
                <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
                  <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
                  <b-spinner class="ml-2" variant="danger"></b-spinner>
                </div>
                <b-alert v-model="flagsDeControle.avisoDeErroNoFormulario.exibir" variant="danger" fade dismissible>
                  <span class="avisoDangerAlerta">{{flagsDeControle.avisoDeErroNoFormulario.mensagem}}</span>
                </b-alert>
                <div class="tab-content" id="vert-tabs-tabContent">
                  <div class="tab-pane text-left fade active show" id="vert-tabs-informacoes" role="tabpanel" aria-labelledby="vert-tabs-informacoes-tab">
                    <Informacoes :buscarInformacoesDoCnpj="buscarInformacoesDoCnpj" :desabilitarCampos="desabilitarCampos" :enderecoLogotipo="formulario.informacoes.endereco_logotipo">
                      <template #informacoes-campos-adicionais-admin>
                        <div class="row col-md-12" v-if="!flagsDeControle.carregandoDados.status">
                          <div class="form-group col-md-12 col-lg-12 col-xl-12">
                              <label for="codigo_empresa">Código Empresa</label>
                              <input type="text" v-model="formulario.informacoes.codigo_empresa" :readonly="!ehEmpresaOffice" :disabled="desabilitarCampos" class="form-control" id="codigo_empresa">
                              <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.codigo_empresa}}</div>
                          </div>
                        </div>
                      </template>
                      <template #informacoes-adicionais>
                        <div class="row col-md-12">
                          <div class="form-group col-md-12">
                            <label for="observacoes">Observações</label>
                            <textarea class="form-control" rows="7" v-model="formulario.informacoes.observacoes" :disabled="desabilitarCampos" id="observacoes" ></textarea>
                            <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.observacoes}}</div>
                          </div>

                          <div class="form-group col-md-12 col-lg-4 col-xl-3" v-if="ehEmpresaOffice">
                            <label for="status_empresa">Status</label>
                            <select v-model="formulario.informacoes.status" class="form-control" id="status_empresa" :disabled="desabilitarCampos">
                              <option :value="1">Ativo</option>
                              <option :value="0">Inativo</option>
                              <option :value="2">Inadimplente</option>
                              <option :value="3">Suspenso</option>
                            </select>
                            <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.status}}</div>
                          </div>

                          <div v-if="!formulario.informacoes.data_inativacao" class="form-group col-md-12 col-lg-12 col-xl-12">
                              <label for="data_cadastro">Data Cadastro</label>
                              <input type="text" v-model="formulario.informacoes.data_cadastro" readonly class="form-control" id="data_cadastro">
                          </div>
                          <div v-else class="form-group col-md-12 col-lg-12 col-xl-12">
                              <label for="data_cadastro">Data Cadastro</label>
                              <input type="text" v-model="formulario.informacoes.data_cadastro" readonly class="form-control" id="data_cadastro">
                          </div>
                          <div v-if="formulario.informacoes.data_inativacao" class="form-group col-md-12 col-lg-12 col-xl-12">
                              <label for="data_inativacao">Data Inativação</label>
                              <input type="text" v-model="formulario.informacoes.data_inativacao" readonly class="form-control" id="data_inativacao">
                          </div>
                        </div>
                      </template>
                    </Informacoes>
                  </div>
                  <div class="tab-pane fade" id="vert-tabs-endereco" role="tabpanel" aria-labelledby="vert-tabs-endereco-tab">
                    <AbaEndereco v-model="formulario.endereco"/>
                  </div>
                  <div class="tab-pane fade" id="vert-tabs-contato" role="tabpanel" aria-labelledby="vert-tabs-contato-tab">
                    <Contato :desabilitarCampos="desabilitarCampos"/>
                  </div>
                  <div class="tab-pane fade produtos" id="vert-tabs-produtos" role="tabpanel" aria-labelledby="vert-tabs-produtos-tab" v-if="ehEmpresaOffice">
                    <PainelGestaoProdutos v-if="abaSelecionada.produtos" :idEmpresa="obterIdEmpresa"/>
                  </div>
                  <!-- <div class="tab-pane fade" id="vert-tabs-consumo" role="tabpanel" aria-labelledby="vert-tabs-consumo-tab" v-if="!ehEmpresaOffice">
                    <MonitoramentoConsumo :listaConsumos="listaConsumos" :fields="fields" :flagsDeControle="flagsDeControle"/>
                  </div> -->
                  <div class="tab-pane fade recursos" id="vert-tabs-recurso" role="tabpanel" aria-labelledby="vert-tabs-recurso-tab">
                    <RecursosListagem :recursos="listaRecursos" :esconderBotaoAdicionar="true" :esconderBotaoCancelar="true" :flagsDeControle="flagsDeControle"/>
                    <div class="d-flex justify-content-end mt-5" v-if="!ehEmpresaOffice && informacoesContrato.id">
                      <div class="d-flex flex-row">
                        <p style="color: gray;">Exclua esta conta e todos os seus dados.</p>
                        <b-link
                          @click="cancelamentoConta(informacoesContrato.id, informacoesContrato)"
                          class="ml-1" style="text-decoration: underline;"
                        >clicando aqui</b-link>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade pedidos" id="vert-tabs-pedidos" role="tabpanel" aria-labelledby="vert-tabs-pedidos-tab" v-if="!ehEmpresaOffice">
                    <Pedidos v-if="abaSelecionada.pedidos" :idEscritorio="formulario.id"/>
                  </div>
                  <div class="tab-pane fade faturas" id="vert-tabs-faturas" role="tabpanel" aria-labelledby="vert-tabs-faturas-tab" v-if="!ehEmpresaOffice">
                    <Faturas v-if="abaSelecionada.faturas" :idEscritorio="formulario.id"/>
                  </div>
                  <div class="tab-pane fade usuarios" id="vert-tabs-usuarios" role="tabpanel" aria-labelledby="vert-tabs-usuarios-tab" v-if="!ehEmpresaOffice">
                    <Usuarios v-if="abaSelecionada.usuarios" :idEmpresa="obterIdEmpresa"/>
                  </div>
                  <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex align-items-center">
                    <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
                    <b-spinner class="ml-2" variant="danger"></b-spinner>
                  </div>
                </div>
              </div>
            </div>
          </div> <!-- ./ card-body ends-->
          <div class="card-footer text-right">
            <div class="row btn-group btn-group-justified" role="group">
              <div class="mr-1"><b-button class="botoes" variant="outline-success btn-sm mt-2" :disabled="desabilitarCampos" @click="salvarRegistro()">Salvar</b-button></div>
              <router-link class="" to="/escritorios">
                <b-button class="botoes" variant="outline-primary btn-sm mt-2" :disabled="desabilitarCampos">Voltar</b-button>
              </router-link>
            </div>
          </div>
        </div> <!-- ./ card ends-->
      </section> <!-- ./ content -->
    </div> <!-- /.content-wrapper -->
  </div> <!-- ./wrapper -->
</template>

<script>
import EdicaoEscritorioAdministracao from './js/edicao-escritorio-administracao'
export default EdicaoEscritorioAdministracao
</script>

<style scoped>
@import "./scss/edicao-escritorio.scss";
</style>
